export default (route, router, queryKeys = []) => {
  const clear = queryKeys.reduce((acc, key) => ({ ...acc, [key]: undefined }), {});
  router.replace({ query: { ...route.query, ...clear } });
};
